module.exports = __webpack_public_path__ + "img/img31.f26053c5.svg";